// src/pages/Unsubscribe.jsx
import { useEffect, useState } from 'react';

export default function Unsubscribe() {
  const qs = new URLSearchParams(window.location.search);
  const qsEmail = qs.get('email') || '';
  const qsSig = qs.get('sig') || '';
  const locked = !!qsEmail; // if present in URL, lock the field

  const [email, setEmail] = useState(qsEmail);
  const [exists, setExists] = useState(null);
  const [subscribed, setSubscribed] = useState(null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type:'', text:'' });

  const apiBase = process.env.REACT_APP_BASE_URL;

  const load = async () => {
    if (!email.trim()) return;
    setMsg({type:'', text:''}); setLoading(true);
    try {
      const url = new URL(`${apiBase}/public/subscription/status`);
      url.searchParams.set('email', email.trim());
      if (qsSig) url.searchParams.set('sig', qsSig);
      const res = await fetch(url.toString());
      const j = await res.json();
      setExists(j.exists);
      setSubscribed(j.subscribed);
      if (!j.exists) setMsg({ type:'warning', text:'Keine Buchung unter dieser E-Mail gefunden.' });
    } catch {
      setMsg({ type:'danger', text:'Fehler beim Laden.' });
    } finally { setLoading(false); }
  };

  const update = async (val) => {
    setMsg({type:'', text:''}); setLoading(true);
    try {
      const res = await fetch(`${apiBase}/public/subscription/update`, {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({ email: email.trim(), subscribed: val, sig: qsSig || undefined })
      });
      if (!res.ok) throw new Error();
      const j = await res.json();
      setSubscribed(j.subscribed);
      setMsg({ type:'success', text: val ? 'Sie sind wieder angemeldet.' : 'Sie wurden erfolgreich abgemeldet.' });
    } catch {
      setMsg({ type:'danger', text:'Aktualisierung fehlgeschlagen.' });
    } finally { setLoading(false); }
  };

  useEffect(()=>{ if (email) load(); /* eslint-disable-next-line */ },[]);

  return (
    <div className="container py-5" style={{maxWidth: 640}}>
      <h3>Newsletter-Einstellungen</h3>
      <p className="text-muted">Verwalten Sie Ihre E-Mail-Benachrichtigungen zum Komponist*innen Musikfestival.</p>

      {!locked ? (
        <div className="mb-3">
          <label className="form-label">E-Mail-Adresse</label>
          <div className="d-flex gap-2">
            <input className="form-control" value={email} onChange={e=>setEmail(e.target.value)} />
            <button className="btn btn-outline-primary" disabled={!email || loading} onClick={load}>Prüfen</button>
          </div>
        </div>
      ) : (
        <div className="mb-3">
          <label className="form-label">E-Mail-Adresse</label>
          <div className="form-control bg-light" aria-readonly>{email}</div>
        </div>
      )}

      {msg.text && <div className={`alert alert-${msg.type}`}>{msg.text}</div>}

      {exists !== null && (
        <div className="card p-3">
          <div className="mb-2">
            Status: {subscribed === null ? '—' : (subscribed ? 'Angemeldet' : 'Abgemeldet')}
          </div>
          <div className="d-flex gap-2">
            <button className="btn btn-danger" disabled={!email || loading || subscribed===false} onClick={()=>update(false)}>
              Abmelden
            </button>
            <button className="btn btn-success" disabled={!email || loading || subscribed===true} onClick={()=>update(true)}>
              Wieder anmelden
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
